export type SiteStats = {
  total_customers: number
  total_completed_transactions: number
}

export function extractSiteStatsFromApiResponse(resp: unknown): SiteStats | null {
  const r = resp as any

  if (r && r.success === false) {
    const msg = typeof r.message === 'string' && r.message.trim() ? r.message : 'Request failed'
    throw new Error(msg)
  }

  const data = r?.data
  const row = Array.isArray(data) ? data?.[0] : data

  if (!row) return null

  return {
    total_customers: Number(row.total_customers ?? 0),
    total_completed_transactions: Number(row.total_completed_transactions ?? 0),
  }
}
